import Component from '../abstracts/Component';
import WishlistLogic from "../logics/WishlistLogic";
import TrackingComponent from '../components/TrackingComponent';

export default class WishlistComponent extends Component {

  get COMPONENTNAME() {
    return 'WishlistComponent';
  }

  get SELECTORS() {
    return {
      wishBtn: '[data-wishlist-btn]',
      headerWishlistIcon: '[data-wishlist-icon]',
      wishRemoveBtn: '[data-wish-remove]',
      sizeSelector: '[data-size-selector]',
      wishlistEmptySection: "[data-wishlist-empty]",
      wishlistFullSection: "[data-wishlist-full]"
    };
  }

  get CLASSES() {
    return {
      error: 'error',
    };
  }

  constructor(el) {
    super(el);
    this.wishlistLogic = new WishlistLogic();
    this.trackingComponent = new TrackingComponent();
    // all wishlist buttons
    this.wishBtns = document.querySelectorAll(this.SELECTORS.wishBtn);
    this.headerWishlistIcon = document.querySelector(this.SELECTORS.headerWishlistIcon);

    //wishlist page
    this.wishRemoveBtns = document.querySelectorAll(this.SELECTORS.wishRemoveBtn);
    this.sizeSelectors = document.querySelectorAll(this.SELECTORS.sizeSelector);
    this.wishlistEmptySection = document.querySelectorAll(this.SELECTORS.wishlistEmptySection);
    this.wishlistFullSection = document.querySelectorAll(this.SELECTORS.wishlistFullSection);
  }

  // GENERAL HANDLING //
  async handleWishlistClick(wishBtns) {
    if (!wishBtns?.length) return;

    wishBtns.forEach(button => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();

        // Prevent multiple clicks
        if (button.disabled) return;
        button.disabled = true;

        try {
          const isInWishlist = button.dataset.wishlistBtn === 'true';
          const isPdp = button.dataset.isPdp === 'true';

          let response, qty;

          if (isInWishlist) {
            // product is in the wishlist
            response = await this.wishlistLogic.removeFromWishlist(
              button.dataset.wishRemoveUrl,
              button.dataset.code
            );
            const json = await response.json();
            qty = parseInt(json.count, 10);
            // there are items in the wishlist
            if (!isNaN(qty) && qty === 0) {
              this.wishlistLogic.updateHeaderWishlistIcon(this.headerWishlistIcon, true);
            }

            this.$emit(this.$customEvents.PRODUCT_EVENTS.removedfromwish, { elem: button, qty });
            this.updateButtonUI(button, false, isPdp);
            button.dataset.wishlistBtn = 'false';

          } else {
            // product is not in the wishlist
            response = await this.wishlistLogic.addToWishlist(
              button.dataset.wishAddUrl,
              button.dataset.code
            );
            const text = await response.text();
            qty = parseInt(text, 10);
            // there are items in the wishlist
            if (!isNaN(qty) && qty > 0) {
              this.wishlistLogic.updateHeaderWishlistIcon(this.headerWishlistIcon, false);
            }

            this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtowish, { elem: button, qty });
            this.trackingComponent.trackAction("wishlistAdd", button.dataset, button);
            this.updateButtonUI(button, true, isPdp);
            button.dataset.wishlistBtn = 'true';
          }

        } catch (err) {
          console.error("Wishlist operation failed:", err);
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  // Helper method to update the button UI
  updateButtonUI(button, isAdded, isPdp) {
    if (isPdp) {
      this.wishlistLogic.updatePDPButton(button, isAdded);
    } else {
      this.wishlistLogic.updateWishlistIcon(button, !isAdded);
    }
  }

  // WISHLIST PAGE //
  async handleDeleteFromWishlist() {
    if (!this.wishRemoveBtns || this.wishRemoveBtns.length === 0) return;

    this.wishRemoveBtns.forEach(button => {
      button.addEventListener("click", async event => {
        event.preventDefault();
        event.stopPropagation();

        const url = button.dataset.wishRemoveUrl;
        try {
          const response = await this.wishlistLogic.removeFromWishlist(
            url,
            button.dataset.code
          );

          if (!response.ok) {
            console.error("Wishlist remove failed with status:", response.status);
            return;
          }

          const data = await response.json();
          const qty = parseInt(data.count, 10);

          // update header only if qty is 0
          if (!isNaN(qty) && qty === 0) {
            this.wishlistLogic.updateHeaderWishlistIcon(this.headerWishlistIcon, true);
          }

          // remove the product from the DOM only after success
          const prodCard = document.querySelector(
            `[data-card-code="${button.dataset.code}"]`
          );
          if (prodCard) prodCard.remove();

          this.$emit(this.$customEvents.PRODUCT_EVENTS.removedfromwish, {
            elem: button,
            qty
          });
        } catch (err) {
          console.error("Error while removing from wishlist:", err);
        }
      });
    });
  }

  listenSelectWishSize() {
    if(this.sizeSelectors) {
      this.sizeSelectors.forEach(sizeSelector => {
        sizeSelector.addEventListener("change", event => {
          if(event.target.selectedOptions.length > 0) {
            const selectedOption = event.target.selectedOptions[0];
            sizeSelector.parentElement.classList.remove(this.CLASSES.error);

            // Remove aria-invalid and error message for screen readers
            sizeSelector.removeAttribute("aria-invalid");
            const errorMsg = sizeSelector.parentElement.querySelector('.sr-size-error');
            if (errorMsg) {
              errorMsg.remove();
            }

            const wishlistInfo = sizeSelector.closest("[data-wishlist-info]");
            let notifymeButton = null;
            let addToCartButton = null;
            if(wishlistInfo) {
              notifymeButton = wishlistInfo.querySelector("[data-js-component='NotifyMeComponent']");
              addToCartButton = wishlistInfo.querySelector("[data-js-component='AddToCartComponent']");
            }

            if(notifymeButton) {
              notifymeButton.querySelector("#productCode") ? notifymeButton.querySelector("#productCode").value = event.target.value : '';
            }

            if(addToCartButton) {
              this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechangedwish,
                {
                  itemIndex: wishlistInfo.dataset.wishlistInfo,
                  productCode: event.target.value
                }
              );
            }

            const isUnavailable = event.target.selectedOptions[0].dataset.unavailable == 'true';
            if(isUnavailable) {
              this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, {productCode: selectedOption.dataset.selectedProductCode});
            } else {
              this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, {productCode: selectedOption.dataset.selectedProductCode});
            }
          }
        });
      });
    }
  }

  bindEvents() {
    let ctx = this;

    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      let qty = payload.qty;
      if(!isNaN(qty) && qty > 0){
        if(ctx.wishlistFullSection && ctx.wishlistFullSection?.length){
          ctx.wishlistFullSection.forEach(elem => {
            if(elem.classList.contains("--hidden")) {
              elem.classList.remove("--hidden");
            }
          })
          ctx.wishlistEmptySection.forEach(elem => {
            elem.classList.add("--hidden");
          })
        }
      } else {
        if(ctx.wishlistEmptySection && ctx.wishlistEmptySection?.length){
          ctx.wishlistEmptySection.forEach(elem => {
            if(elem.classList.contains("--hidden")) {
              elem.classList.remove("--hidden");
            }
          })
          ctx.wishlistFullSection.forEach(elem => {
            elem.classList.add("--hidden");
          })
        }
      }
    });

    //TODO uniquesize

    //PDP size change
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      // search the btn with the base product code
      const wishlistButton = document.querySelector('[data-wishlist-code="'+payload.baseProductCode+'"]');
      if(wishlistButton) {
        wishlistButton.dataset.code = payload.productCode;
        this.wishlistLogic.wishlistCheckAjax(payload.productCode).then(result => {
          if (result === 'true') {
            this.wishlistLogic.updatePDPButton(wishlistButton, true);
          } else {
            this.wishlistLogic.updatePDPButton(wishlistButton, false);
          }
        });
      }
    });

    // event simplebar loader
    this.$on(this.$customEvents.SIMPLEBAR_EVENTS.loaded, ({event, payload}) => {
      const wishlistButtons = payload.elem.querySelectorAll(this.SELECTORS.wishBtn);
      if (wishlistButtons) this.handleWishlistClick(wishlistButtons);
    });

    // Size not selected event wishlist page
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, ({event, payload}) => {
      const sizeBox = document.querySelector('[data-sizes-code=prod_'+payload.getAttribute('data-product-code')+']');
      if (sizeBox.querySelector(".custom-select")) {
        const selectWrapper = sizeBox.querySelector(".custom-select");
        selectWrapper.classList.add(this.CLASSES.error);

        // Add aria-invalid and aria-live announcement for screen readers
        const selectElement = selectWrapper.querySelector("select");
        if (selectElement) {
          selectElement.setAttribute("aria-invalid", "true");

          // Create or update screen reader announcement
          let errorMsg = selectWrapper.querySelector('.sr-size-error');
          if (!errorMsg) {
            errorMsg = document.createElement('span');
            errorMsg.className = 'sr-size-error sr-only';
            errorMsg.setAttribute('role', 'alert');
            errorMsg.setAttribute('aria-live', 'assertive');
            selectWrapper.appendChild(errorMsg);
          }
          errorMsg.textContent = payload.getAttribute('data-notification');
        }
      }
    });

    // listing page when launched the filters i need to rebind all buttons
    this.$on(this.$customEvents.RECOMMENDATION_EVENTS.loaded+'.mmfg '+this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // we need to get buttons from document instead of payload in order to register event listener
      this.wishBtns = document.querySelectorAll(this.SELECTORS.wishBtn);
      if(this.wishBtns) {
        this.handleWishlistClick(this.wishBtns);
      }
    });

    // listing when fired pagination and infinite scroll
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, ({event, payload}) => {
      const newProducts = payload.newProducts;
      const wishlistBtns = [];
      if(newProducts) {
        newProducts.forEach(newProduct => {
          const wishlistBtn = newProduct.querySelector(this.SELECTORS.wishBtn);
          wishlistBtn ? wishlistBtns.push(wishlistBtn) : '';
        });
      }
      if (wishlistBtns) this.handleWishlistClick(wishlistBtns);
    });
  }

  render() {
    this.log('Rendering...');
    this.bindEvents();
    this.handleWishlistClick(this.wishBtns);
    this.handleDeleteFromWishlist();
    this.listenSelectWishSize();
  }
}
